import React from 'react';
import { Row, Form, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
export default function SelectManager(_ref) {
  var _claimGroup$admin;
  let {
    accountType,
    claimGroup,
    onChange,
    admins,
    isUnderReview
  } = _ref;
  claimGroup.admin_id = claimGroup.admin_id || ((_claimGroup$admin = claimGroup.admin) === null || _claimGroup$admin === void 0 ? void 0 : _claimGroup$admin.id);
  const {
    t
  } = useTranslation();
  const avaibableForAccountTypes = ['admin', 'consultant', 'super_consultant', 'manager'];
  const isDisabled = !avaibableForAccountTypes.includes(accountType) || isUnderReview;
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('manager'), "*"), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 5,
      offset: 4
    }
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    disabled: isDisabled,
    value: claimGroup.admin_id,
    name: "admin_id",
    onChange: onChange,
    size: "md",
    type: "text"
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), admins.sort((a, b) => a.name.localeCompare(b.name)).map(admin => {
    return /*#__PURE__*/React.createElement("option", {
      key: admin.id,
      value: admin.id
    }, admin.name);
  }))));
}